module.exports = __webpack_public_path__ + "img/qycg.5fb91f7.png";